import type {ReplacementOption} from './types';

export function replacementStock(item:ReplacementOption):string {
 if(item.stockStatus==='SignInRequired')return 'Наличие после входа';
 if(item.stockStatus==='Available')return `Есть на ${item.requiredQuantity} ${item.unitName}`;
 if(item.stockStatus==='Shortage')return item.coveredQuantity===0?'Нет на складе':`Есть ${item.coveredQuantity} из ${item.requiredQuantity} ${item.unitName}`;
 return 'Наличие не подтверждено';
}
export function replacementDetails(item:ReplacementOption):string {
 const price=item.unitPrice==null?'Цена не подтверждена':`${new Intl.NumberFormat('ru-KG',{maximumFractionDigits:4}).format(item.unitPrice)} сом/${item.unitName}`;
 return `${price} · ${replacementStock(item)}`;
}

export function replacementLabel(item:ReplacementOption):string { return `${item.name} · ${replacementDetails(item)}`; }
